import { render, staticRenderFns } from "./StudioOpenTokLiveStream.vue?vue&type=template&id=b8996ca8&scoped=true&"
import script from "./StudioOpenTokLiveStream.vue?vue&type=script&lang=js&"
export * from "./StudioOpenTokLiveStream.vue?vue&type=script&lang=js&"
import style0 from "./StudioOpenTokLiveStream.vue?vue&type=style&index=0&id=b8996ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8996ca8",
  null
  
)

export default component.exports